import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "user-logout",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      dialogVisible: false,
      loadingDialog: false,
      form: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _res$data;
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pn = 1;
              }
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getLogoutUserList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list.map(function (item) {
                var cancelMethod = '';
                if (item.cancelMethod === 1) {
                  cancelMethod = '用户注销';
                } else if (item.cancelMethod === 2) {
                  cancelMethod = '管理员注销';
                }
                return _objectSpread(_objectSpread({}, item), {}, {
                  cancelMethod: cancelMethod
                });
              })) || [];
              _this2.total = res.data.count;
              _this2.tableLoading = false;
              _this2.getUserListByIds(_this2.tableData, "id");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    logoutUser: function logoutUser() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loadingDialog = true;
              _context3.n = 1;
              return _this3.$api.logoutUser(_this3.form);
            case 1:
              res = _context3.v;
              // 操作上报
              _this3.$operationLog.push({
                code: "deactivate",
                userId: res.data.userId,
                operationType: "user"
              });
              if (res.data.success) {
                _this3.$message.success("操作成功");
                _this3.dialogVisible = false;
                _this3.getData();
              } else {
                _this3.$message.warning(res.data.message);
              }
              _this3.loadingDialog = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};